import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withKeys as _withKeys, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gfu-grid gfu-grid--gutter-columns" }
const _hoisted_2 = {
  class: "gfu-grid__cell gfu-1of1 gfu-4of12--m",
  "data-qa": "espago-form:FirstName"
}
const _hoisted_3 = {
  class: "gfu-grid__cell gfu-1of1 gfu-4of12--m",
  "data-qa": "espago-form:LastName"
}
const _hoisted_4 = {
  class: "gfu-grid__cell gfu-1of1 gfu-4of12--m _fc",
  "data-qa": "espago-form:CardNumber"
}
const _hoisted_5 = { class: "gfu-grid__cell gfu-1of1 gfu-4of12--m" }
const _hoisted_6 = { class: "gfu-grid gfu-grid--gutter-columns" }
const _hoisted_7 = { class: "gfu-grid__cell gfu-1of2 gfu-8of12--m _mt-1" }
const _hoisted_8 = { class: "gfu-grid gfu-grid--gutter-columns" }
const _hoisted_9 = {
  class: "gfu-grid__cell gfu-5of12",
  "data-qa": "espago-form:CardExpMonth"
}
const _hoisted_10 = {
  class: "gfu-grid__cell gfu-7of12",
  "data-qa": "espago-form:CardExpYear"
}
const _hoisted_11 = {
  class: "gfu-grid__cell gfu-1of2 gfu-4of12--m",
  "data-qa": "espago-form:CvC"
}
const _hoisted_12 = {
  class: "gfu-grid__cell gfu-1of1 _cf _mt-3 _tc--light",
  "data-qa": "espago-form:LearnMore"
}
const _hoisted_13 = { class: "_mb-3" }
const _hoisted_14 = { class: "_tal" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_notificator = _resolveComponent("notificator")
  const _component_text_field = _resolveComponent("text-field")
  const _component_field = _resolveComponent("field")
  const _component_field_label = _resolveComponent("field-label")
  const _component_number_field = _resolveComponent("number-field")
  const _component_base_image = _resolveComponent("base-image")
  const _component_modal_box = _resolveComponent("modal-box")

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_notificator, {
      ref: "notify",
      singular: true,
      "ensure-shown": true
    }, null, 512 /* NEED_PATCH */),
    _cache[13] || (_cache[13] = _createElementVNode("h2", { class: "gfu-heading gfu-heading--top-divider" }, "Credit card payment", -1 /* CACHED */)),
    _cache[14] || (_cache[14] = _createTextVNode(" Please enter your card details. ", -1 /* CACHED */)),
    _createElementVNode("fieldset", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_text_field, {
          modelValue: $data.model.firstName,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.model.firstName) = $event)),
          name: "model.firstName",
          "display-name": "Cardholder's first name",
          onKeyup: _withKeys($options.submit, ["enter"])
        }, null, 8 /* PROPS */, ["modelValue", "onKeyup"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_text_field, {
          modelValue: $data.model.lastName,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.model.lastName) = $event)),
          name: "model.lastName",
          "display-name": "Cardholder's last name",
          onKeyup: _withKeys($options.submit, ["enter"])
        }, null, 8 /* PROPS */, ["modelValue", "onKeyup"])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_text_field, {
          modelValue: $data.model.creditCardNumber,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (($data.model.creditCardNumber) = $event)),
          class: _normalizeClass([{ 'has-error': $options.isformattedCreditCardNumberWrong }]),
          name: "model.creditCardNumber",
          "display-name": "Card number",
          "text-align": "left",
          "validator-layout": "none",
          "on-change": $options.charactersGroup,
          maxlength: 23,
          onKeyup: _withKeys($options.submit, ["enter"])
        }, null, 8 /* PROPS */, ["modelValue", "class", "on-change", "onKeyup"]),
        _createVNode(_component_field, {
          class: "_ma-0",
          name: "model.formattedCreditCardNumber",
          "display-name": "Card number",
          "show-label": false
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_field_label, {
              class: "_mt-1",
              text: "Card expiration date",
              "is-required": true
            }),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_number_field, {
                  modelValue: $data.model.monthExpire,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => (($data.model.monthExpire) = $event)),
                  class: "_ma-0",
                  name: "model.monthExpire",
                  "display-name": "Month",
                  placeholder: "MM",
                  "show-label": false,
                  integer: true,
                  "remove-zeros": false,
                  maxlength: 2,
                  onKeyup: _withKeys($options.submit, ["enter"])
                }, null, 8 /* PROPS */, ["modelValue", "onKeyup"])
              ]),
              _cache[8] || (_cache[8] = _createElementVNode("div", { class: "gfu-divider" }, "/", -1 /* CACHED */)),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_number_field, {
                  modelValue: $data.model.yearExpire,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => (($data.model.yearExpire) = $event)),
                  class: "_ma-0",
                  name: "model.yearExpire",
                  "display-name": "Year",
                  placeholder: "YYYY",
                  "show-label": false,
                  integer: true,
                  "remove-zeros": false,
                  maxlength: 4,
                  onKeyup: _withKeys($options.submit, ["enter"])
                }, null, 8 /* PROPS */, ["modelValue", "onKeyup"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_number_field, {
              modelValue: $data.model.cvc,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => (($data.model.cvc) = $event)),
              name: "model.cvc",
              "display-name": "CVV/CVC",
              integer: true,
              "remove-zeros": false,
              maxlength: 4,
              onKeyup: _withKeys($options.submit, ["enter"])
            }, null, 8 /* PROPS */, ["modelValue", "onKeyup"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _cache[9] || (_cache[9] = _createTextVNode(" All credit card information is securely processed by Espago. ", -1 /* CACHED */)),
        _createElementVNode("a", {
          class: "gfu-link gfu-link--accent _ml-1",
          href: "",
          onClick: _cache[6] || (_cache[6] = _withModifiers((...args) => ($options.showEspagoMessageBox && $options.showEspagoMessageBox(...args)), ["prevent"]))
        }, "Learn more.")
      ])
    ]),
    _createVNode(_component_modal_box, {
      "is-visible": $data.isVisible,
      title: "About Espago",
      width: "narrow"
    }, {
      actions: _withCtx(() => [
        _createElementVNode("button", {
          type: "button",
          class: "gfu-btn gfu-btn--accent gfu-btn--soft gfu-btn--wide gfu-btn--compact",
          onClick: _cache[7] || (_cache[7] = _withModifiers((...args) => ($options.closeEspagoMessageBox && $options.closeEspagoMessageBox(...args)), ["prevent"]))
        }, "Ok")
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_base_image, {
            style: {"width":"100px"},
            src: "/content/images/payments/logo-espago.svg",
            alt: "Espago"
          }),
          _cache[10] || (_cache[10] = _createElementVNode("div", { class: "_tc--light" }, "Secure payments", -1 /* CACHED */))
        ]),
        _cache[11] || (_cache[11] = _createElementVNode("div", { class: "_mb-3" }, " Your data is secure. Espago takes the highest tier - Level1 - in the yearly, independent Payment Card Industry Data Security Standard audits. ", -1 /* CACHED */)),
        _cache[12] || (_cache[12] = _createElementVNode("div", { class: "_mb-3" }, " We protect transactions against fraud by monitoring and preventing card fraud. We use 3D Secure protection: Veryfied by Visa, Mastercard Secure Code and American Express SafeKey. ", -1 /* CACHED */)),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_base_image, {
            src: "/content/images/payments/logo-visa.png",
            class: "_mr-6",
            alt: "Visa"
          }),
          _createVNode(_component_base_image, {
            src: "/content/images/payments/logo-mastercard.png",
            class: "_mr-6",
            alt: "Mastercard"
          }),
          _createVNode(_component_base_image, {
            src: "/content/images/payments/logo-safekey.png",
            alt: "SafeKey"
          })
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["is-visible"])
  ]))
}